export {
    default as Logo,
    ILogoProps,
} from './logo';
